import { render } from "./ELECTED_VAL_REVOKED.vue?vue&type=template&id=0694838e"
import script from "./ELECTED_VAL_REVOKED.vue?vue&type=script&lang=js"
export * from "./ELECTED_VAL_REVOKED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__